import React, { useState, Suspense, lazy } from 'react';
import Navbar from '../src/Component/Navbar';
import HeroSection from '../src/Component/Hero';
import LogoScroller from './Component/LogoScroller.jsx';
import AboutSection from './Component/AboutUs/AboutSection.jsx';
import Footer from './Component/Footer/Footer.jsx';
import CompanyTestimonial from './Component/Testimonial/CompanyTestimonial.jsx';
import FreeConsultancyPlan from './Component/ConsultancyPlan/FreeConsultancyPlan.jsx';
import Terms from './Component/LegalLinks/Terms.jsx';
import Privacy from './Component/LegalLinks/Privacy.jsx';
import Cookies from './Component/LegalLinks/Cookies.jsx';
import Consulting from './Component/ConsutingServe/Consulting.jsx';
import GenAI from './Component/GenAI/GenAI.jsx';
import Seo from './Component/SEO/Seo.jsx';
import LazyOnVisible from './Component/LazyOnVisible.jsx';
import { organizationSchema, websiteSchema, serviceSchema } from './Component/SEO/schema.js';

// Code-split: pulls in react-simple-maps/d3-geo and fetches an external
// world-atlas topojson file, none of which should be paid for on first load.
const Test = lazy(() => import('./Component/Testing/Test.jsx'));

const HOME_DESCRIPTION =
  'Vorstel is an AI-enabled digital transformation consultancy helping enterprises with AI consulting, cloud migration, modern enterprise architecture, and scalable web & mobile solutions.';

const Home = () => {
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'sap', or 'gen'

  function handleActiveTabChange(active) {
    setActiveTab(active);
  }

  return (
    <>
      <Seo
        title="AI-Enabled Digital Transformation Consulting"
        description={HOME_DESCRIPTION}
        path="/"
        jsonLd={[
          organizationSchema,
          websiteSchema,
          serviceSchema('Digital Transformation Consulting', 'Strategic consulting to help businesses navigate digital transformation.'),
          serviceSchema('AI Enabled Innovation', 'Leveraging AI to drive innovation and competitive advantage.'),
          serviceSchema('Cloud & Infrastructure', 'Reliable, scalable cloud migration and infrastructure solutions.'),
        ]}
      />
      <Navbar onActiveTabChange={handleActiveTabChange} />
      <div id='HeroSection'>
        <HeroSection />
      </div>
      <div id='Consulting'>
        <Consulting />
      </div>
      <div id='DesignServices'>
         <LogoScroller /> 
      </div>
      <div id='Gen'>
        <GenAI />
      </div>
       <div id='AboutSection'>
        <AboutSection />
      </div>
      <div id='ContactUs'>
        <FreeConsultancyPlan />
        <CompanyTestimonial />
      </div>
      <LazyOnVisible minHeight={500}>
        <Suspense fallback={null}>
          <Test />
        </Suspense>
      </LazyOnVisible>
      <Footer />
    </>
  );
};

const TermsPage = () => (
  <>
    <Seo
      title="Terms & Conditions"
      description="Read the terms and conditions governing the use of Vorstel's website and consulting services."
      path="/terms"
    />
    <Terms />
  </>
);

const PrivacyPage = () => (
  <>
    <Seo
      title="Privacy Policy"
      description="Learn how Vorstel collects, uses, and protects your personal data."
      path="/privacy"
    />
    <Privacy />
  </>
);

const CookiesPage = () => (
  <>
    <Seo
      title="Cookies Policy"
      description="Understand how Vorstel uses cookies to improve your browsing experience."
      path="/cookies"
    />
    <Cookies />
  </>
);

// vite-react-ssg route records: a plain data-router array (not JSX <Routes>),
// so every path here gets statically pre-rendered to real HTML at build time.
export const routes = [
  { path: '/', Component: Home },
  { path: '/terms', Component: TermsPage },
  { path: '/privacy', Component: PrivacyPage },
  { path: '/cookies', Component: CookiesPage },
];

export default routes;
